module.exports = __webpack_public_path__ + "static/media/jumping_in_front_of_mountain.16892db4.jpg";